<template>
    <div v-loading="loading" class="previewBox">
        <div v-if="fileInfo.fileFormat == 'mp3' || fileInfo.fileFormat == 'wav' || fileInfo.fileFormat == 'm4a'" class="iframeBox text_center">
            <img src="~@/assets/img/audioDefault.png" class="audioIcon">
            <audio class="w100" controls :src="fileInfo.netUrl"></audio>
        </div>
        <iframe class="iframeBox" id="frame" :src='onlinePreviewSrc' v-if="fileInfo.fileFormat != 'mp3' && fileInfo.fileFormat != 'wav' && fileInfo.fileFormat != 'm4a' && fileInfo.basicAssemblyId != '23'"></iframe>
        <iframe class="iframeBox" v-show="fileInfo.basicAssemblyId == '23'" id="mainIframe" ref="mainIframe" name="mainIframe" :src="threeSrc" frameborder="0" width="100%" height="100%"/>
    </div>
</template>

<script>
    import {Base64} from 'js-base64'
    export default {
        data() {
            return {
                loading: false,
                threeSrc: '/static/threeJs/examples/basics_obj.html',
                fileInfo: {},
                onlinePreviewSrc: '',
            }
        },
        mounted() {
            this.loading = true
            this.fileInfo = JSON.parse(sessionStorage.getItem('previewFileInfo'))
            this.onlinePreview(this.fileInfo.netUrl, this.fileInfo.fileName).then(result => {
                this.onlinePreviewSrc = result
            })
            this.$nextTick(() => {
                if(this.fileInfo.netUrl || this.fileInfo.threeList) {
                    this.init()
                } else {
                    this.$message.error('预览失败');
                    this.loading = false
                }
            })
        },
        methods: {
            init() {
                this.loading = false
                if(this.fileInfo.basicAssemblyId == '23') {
                    this.showThree(this.fileInfo.threeList)
                }
            },
            // 展示三维
            showThree(data) {
                let iframeData
                if (data.obj && data.mtl && data.img) {
                    this.threeSrc = '/static/threeJs/examples/basics_obj.html'
                    iframeData = {
                        mtlUrl: data.mtl.netUrl,
                        objUrl: data.obj.netUrl,
                        imgUrl: data.img,
                    }
                } else if (data.stl) {
                    this.threeSrc = '/static/threeJs/examples/basics_stl.html'
                    iframeData = {
                        stlUrl: data.stl.netUrl,
                    }
                }  else if (data.glb) {
                    this.threeSrc = '/static/threeJs/examples/basics_glb.html'
                    iframeData = {
                        stlUrl: data.glb.netUrl,
                    }
                } else {
                    this.$message('缺失文件')
                    return
                }
                const mapFrame = this.$refs['mainIframe']
                mapFrame.contentWindow.location.reload()
                if (mapFrame.attachEvent) {
                    mapFrame.attachEvent('onload', function () {
                        const iframeWin = mapFrame.contentWindow
                        iframeWin.postMessage(iframeData, '*')
                    })
                } else {
                    mapFrame.onload = function () {
                        const iframeWin = mapFrame.contentWindow
                        iframeWin.postMessage(iframeData, '*')
                    }
                }
            },
        },
    }
</script>

<style scoped>
    .iframeBox {
        width: 100%;
        height: 100%;
    }
    .audioIcon {
        height: 90%;
        padding: 5% 0;
    }
    .previewBox {
        height: 100vh;
        overflow-y: hidden;
    }
</style>
